import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPhonepeComponent } from './simple-icons-phonepe.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPhonepeComponent ],
    exports:      [ SimpleIconsPhonepeComponent ],
    bootstrap:    []
})
export class SimpleIconsPhonepeModule {}
